import {type FormEventHandler} from 'react';
import {Dialog, type DialogProps, DialogTitle, DialogContent, Grid, Typography} from '@mui/material';
import {SaveButton} from 'components/buttons';
import {ElevatedInput} from 'components/inputs';
import {FormattedMessage} from 'react-intl';
import {Alert} from 'components/feedbacks';
import {useFormState} from 'hooks';

type CreateBookmarkDialogProps = DialogProps & {
  handleCreateBookmark: Function;
  submitting: boolean;
  errorReason?: string;
}

const CreateBookmarkDialog = ({open, onClose, handleCreateBookmark, submitting, errorReason} : CreateBookmarkDialogProps) : JSX.Element => {
  const [values, onChange] = useFormState({
    bookmarkName: '',
    url: ''
  });

  const handleSubmit : FormEventHandler<HTMLFormElement> = event => {
    event.preventDefault();
    handleCreateBookmark(values);
  }

  return <Dialog open={open} onClose={onClose} fullWidth>
    <form onSubmit={handleSubmit}>
      <DialogTitle>
        <Grid container justifyContent='space-between' alignItems='center'>
          <Grid item>
            <Grid  container alignItems='center'>
              <Typography variant='h6' color='primary'><FormattedMessage id='admin.bookmarks.create.title' /></Typography>
            </Grid>
          </Grid>
          <Grid item>
            <SaveButton className='bg-admin-blue-300 text-grey-white' type='submit' loading={submitting} />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={4}>
          <Grid item xxs={12}>
            <ElevatedInput
              label='Nom'
              name='bookmarkName'
              onChange={onChange}
              required
              fullWidth
              autoFocus
            />
          </Grid>
          <Grid item xxs={12}>
            <ElevatedInput
              label='Adresse URL du site internet'
              name='url'
              onChange={onChange}
              required
              fullWidth
            />
          </Grid>
        </Grid>
      {errorReason && <Alert>
        <Typography><FormattedMessage id={'admin.bookmarks.action.failed.' + errorReason} /></Typography>
      </Alert>}
      </DialogContent>
    </form>
  </Dialog>
}

export default CreateBookmarkDialog;